import { render } from "./OrderDetailPage.vue?vue&type=template&id=336812ac&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"

import "./OrderDetailPage.vue?vue&type=style&index=0&id=336812ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336812ac"]])

export default __exports__